import { createTheme, theme } from '@smiledragon-corp/sds-system';
import { InfoCircleFill } from '../assets/icon/Icons';
import { viewupZIndex } from '../types/zindexTheme';
import { color, text, weight } from './legacyTheme';
import { typography } from './typograpy';

// sds-system 의 모달 기본 maxHeight 는 ['80%', '600px'] (theme/components/modal: [모바일, 데스크톱])
// 인데 이 테마가 isResponsive: false 라 모바일에서도 데스크톱 값인 600px 고정이 걸린다. 뷰포트가
// 그보다 낮으면(소형 기기, 키보드 노출) 모달이 위아래로 잘려 나가고 position: fixed 라 스크롤로도
// 하단 버튼에 닿을 수 없다. 32px 은 상하 16px 씩의 최소 여백. min() 이라 화면이 좁을 때만 낮아지고
// 여유 있는 화면(= 지금까지의 모든 화면)의 레이아웃은 그대로다.
//
// 슬롯은 componentName + slot 으로 해석된다. 모달 카드는 Modal/root(= Dialog.Content) 이고
// AlertModal/root 는 카드 안쪽 wrapper 이므로, 상한은 Modal 쪽에만 둔다.
const MODAL_MAX_HEIGHT = 'min(600px, calc(100svh - 32px))';

export const viewupTheme = createTheme({
  color,

  components: {
    AlertModal: {
      defaultProps: {
        defaultIconSource: InfoCircleFill,
        hasCloseButton: false,
        isResponsive: false,
      },
      styleOverrides: {
        root: {
          height: 'auto',
        },
      },
    },
    Badge: {
      variants: [
        {
          props: { size: '2XS' },
          styles: {
            content: {
              fontSize: '11px',
              height: theme.size['2XS'],
              paddingLeft: '4px',
              paddingRight: '4px',
            },
          },
        },
      ],
    },
    ConfirmModal: {
      defaultProps: {
        isResponsive: false,
      },
    },
    Modal: {
      defaultProps: {
        isResponsive: false,
      },
      styleOverrides: {
        root: {
          height: 'auto',
          maxHeight: MODAL_MAX_HEIGHT,
          maxWidth: 'calc(100% - 16px - 16px)',
          minWidth: '320px',
        },
      },
    },
  },
  palette: {
    bg: {
      infoDimmer: '#3889FFCC',
      point: 'secondary.500',
      pointSubtle: 'secondary.50',
    },
    border: {
      point: 'secondary.500',
    },
    icon: {
      point: 'secondary.500',
    },
    primary: {
      50: '#E7F4FD',
      100: '#B6DCF9',
      200: '#92CBF7',
      300: '#61B4F3',
      400: '#42A5F1',
      500: '#138FED',
      600: '#1182D8',
      700: '#0D66A8',
      800: '#0A4F82',
      900: '#083C64',
    },
    secondary: {
      50: '#FFFAE6',
      100: '#FFEEB0',
      200: '#FFE68A',
      300: '#FFDA54',
      400: '#FFD333',
      500: '#FFC800',
      600: '#E8B600',
      700: '#B58E00',
      800: '#8C6E00',
      900: '#6B5400',
    },
    text: {
      point: 'secondary.500',
    },
  },
  text,
  typography: typography,
  weight,
  zIndex: viewupZIndex,
});
